// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.My-Community>.el-drawer__header {\n  display: none;\n}\n.My-Community>.el-drawer__body {\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
